<template>
	<b-modal ref="modal" hide-footer size="lg">
		<template v-slot:modal-title>
			{{ form.tiersrib_id ? $t('tiers.rib_form.modifier_titre') : $t('tiers.rib_form.ajouter_titre') }}
		</template>

		<form @submit.prevent="onSubmit">
			<div class="row mt-2">
				<label for="tiersrib_content" class="col-sm-4 col-form-label">{{ $t('tiers.rib_form.iban') }} *</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersrib_content"
						class="form-control"
						v-model="form.tiersrib_content"
						required
						autocomplete="chrome-off"
					/>
					<small v-if="invalid_iban" class="text-danger">{{ $t('tiers.rib_form.iban_invalide') }}</small>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersrib_bic" class="col-sm-4 col-form-label">{{ $t('tiers.rib_form.bic') }}</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersrib_bic"
						class="form-control"
						v-model="form.tiersrib_bic"
						maxlength="11"
						autocomplete="chrome-off"
					/>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersrib_label" class="col-sm-4 col-form-label">{{ $t('tiers.rib_form.label') }}</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersrib_label"
						class="form-control"
						v-model="form.tiersrib_label"
					/>
				</div>
			</div>

			<div class="row mt-2">
				<div class="col-sm-8 offset-sm-4">
					<b-form-checkbox
						v-model="form.tiersrib_status"
						value="approuve"
						unchecked-value="quarantaine"
						:disabled="form.tiersrib_default"
					>
						{{ $t('tiers.rib_form.approuve') }}
					</b-form-checkbox>
					<b-form-checkbox v-model="form.tiersrib_default">
						{{ $t('tiers.rib_form.par_defaut') }}
					</b-form-checkbox>
				</div>
			</div>

			<div class="text-center mt-4">
				<button type="submit" class="btn btn-primary btn-rounded" :disabled="processing">
					{{ $t('global.enregistrer') }}
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse/>
					<font-awesome-icon v-else :icon="['fal', 'save']"/>
				</button>
			</div>
		</form>

		<ActionOverlay ref="saveOverlay" />
	</b-modal>
</template>

<script type="text/javascript">
	import Tiers from "@/mixins/Tiers.js"

	export default {
		name: "TiersRibForm",
		mixins: [Tiers],
		props: {
			tiers_id: { type: Number, required: true }
		},
		data() {
			return {
				processing: false,
				invalid_iban: false,
				default_form: {
					tiersrib_id: null,
					tiersrib_content: '',
					tiersrib_bic: '',
					tiersrib_label: '',
					tiersrib_status: 'approuve',
					tiersrib_default: false
				},
				form: {}
			}
		},
		watch: {
			// Désigner un compte comme référence, c'est dire où partiront les virements : cela vaut
			// vérification auprès du fournisseur, et le statut n'est plus dissociable tant que la
			// case reste cochée.
			'form.tiersrib_default'(value) {
				if(value) {
					this.form.tiersrib_status = 'approuve'
				}
			}
		},
		methods: {
			/**
			 * Ouvre la modale en création ou en édition.
			 *
			 * @param {object|null} rib Coordonnée à modifier, nul pour une création.
			 */
			open(rib = null) {
				if(rib) {
					this.form = {
						tiersrib_id: rib.tiersrib_id,
						tiersrib_content: rib.tiersrib_content,
						tiersrib_bic: rib.tiersrib_bic || '',
						tiersrib_label: rib.tiersrib_label || '',
						tiersrib_status: rib.tiersrib_status,
						tiersrib_default: rib.tiersrib_default
					}
				}
				else {
					this.form = { ...this.default_form }
				}

				this.invalid_iban = false
				this.$refs.modal.show()
			},
			close() {
				this.$refs.modal.hide()
			},
			/**
			 * Enregistre la coordonnée bancaire saisie, en création comme en modification.
			 *
			 * @returns {Promise<void>}
			 */
			async onSubmit() {
				if(this.processing) {
					return
				}

				this.processing = true
				this.invalid_iban = false
				this.$refs.saveOverlay.show(this.$t('global.enregistrement_en_cours'))

				const payload = { ...this.form }
				delete payload.tiersrib_id

				const result = await this.saveTiersRib(this.tiers_id, payload, this.form.tiersrib_id)

				if(result) {
					await this.$refs.saveOverlay.showSuccess(this.$t('global.enregistrement_succes'))
					this.processing = false
					this.$emit('submit')
					this.close()
					return
				}

				// La clé de contrôle de l'IBAN est vérifiée par le serveur : un refus vient de là bien
				// plus souvent que d'une panne, et le dire sur le champ épargne à l'utilisateur de
				// chercher son erreur ailleurs.
				this.$refs.saveOverlay.hide()
				this.processing = false
				this.invalid_iban = true
				this.failureToast('toast.info_save_failed')
			}
		},
		components: {
			ActionOverlay: () => import('@/components/Utils/ActionOverlay')
		}
	}
</script>
